import { queryOptions } from '@tanstack/react-query';
import type { EventCategoryDto } from '@upme/contracts';
import { api } from '../../app/api-client';

export const eventCategoriesKey = ['admin', 'event-categories'] as const;

export const listEventCategoriesOptions = () =>
  queryOptions({
    queryKey: [...eventCategoriesKey],
    queryFn: () => api.get('admin/event-categories').json<EventCategoryDto[]>(),
    staleTime: 30_000,
  });

export const eventCategoryByIdOptions = (id: string) =>
  queryOptions({
    queryKey: [...eventCategoriesKey, id],
    queryFn: () => api.get(`admin/event-categories/${id}`).json<EventCategoryDto>(),
  });
